import { useQuery } from "react-query";
import { getClassroom } from "../services/school/classroom/classroom";
import { PagedRequestType } from "../types/PagedResults";
import { Key_classroom, Key_studentsUnsynced } from "../utils/constants";
import { getStudentUnsynced } from "../services/school/student/getStudents";

export const useGetStudentsUnsyncedQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_studentsUnsynced, JSON.stringify(data)],
    () => getStudentUnsynced(data), 
    options?{...options}:{}
  );